import React from "react";
import styled from "styled-components";
import { ORDER_STEPS, stepIndexForStatus } from "../../utils/orderStatus";
import { orderSummaryOf } from "../../utils/groupBasketView";
import { Card, CardTitle, GREEN, GREEN_SOFT, MUTED, Muted, Pill, Row } from "./groupBasketStyles";

/*
 * The order after release, mirrored on the basket for every member
 * (`basket.order`), in the site's own order tracking words and steps.
 */
const GroupBasketOrder = ({ order }) => {
  const summary = orderSummaryOf(order);
  if (!summary) return null;
  const index = stepIndexForStatus(order.deliveryStatus);
  const placedAt = order.placedAt ? new Date(order.placedAt) : null;
  return (
    <Card aria-label="Order status">
      <Row>
        <CardTitle>Order status</CardTitle>
        <Pill $tone={summary.tone}>{summary.label}</Pill>
      </Row>
      {placedAt && !Number.isNaN(placedAt.getTime()) && (
        <Muted>
          Placed at {placedAt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}
        </Muted>
      )}
      {summary.tone !== "danger" && (
        <Steps aria-label="Order progress">
          {ORDER_STEPS.map((step, i) => (
            <li key={step} data-done={index !== null && i <= index ? "true" : "false"}>
              <span className="dot" aria-hidden="true" />
              <span>{step}</span>
            </li>
          ))}
        </Steps>
      )}
    </Card>
  );
};

const Steps = styled.ol`
  list-style: none;
  margin: 14px 0 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;

  li {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 12.5px;
    line-height: 1.3;
    color: ${MUTED};
  }

  .dot {
    height: 6px;
    border-radius: 999px;
    background: ${GREEN_SOFT};
  }

  li[data-done="true"] {
    color: #15232a;
    font-weight: 700;
  }

  li[data-done="true"] .dot {
    background: ${GREEN};
  }
`;

export default GroupBasketOrder;
